import { useEffect, useState } from "react";

const useAssetInfo = (url) => {
	const [assetInfo, setAssetInfo] = useState({ type: "other" });

	useEffect(() => {
		const fetchAssetInfo = async () => {
			try {
				let response = await fetch(url, { method: "HEAD" });

				if (!response.ok || !response.headers.get("Content-Type")) {
					response = await fetch(url, {
						headers: {
							Range: "bytes=0-0",
						},
					});
				}

				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}

				const contentType = response.headers.get("Content-Type");

				let type = "other";
				if (contentType) {
					if (contentType.startsWith("image/")) {
						type = "image";
					} else if (contentType.startsWith("video/")) {
						type = "video";
					}
				}

				setAssetInfo({ type });
			} catch (error) {
				setAssetInfo({ type: "other", error: error.message });
			}
		};

		fetchAssetInfo();
	}, [url]);

	return assetInfo;
};

export default useAssetInfo;
